export function formatLookupCategoryLabel(slug: string | null | undefined): string {
  if (slug == null || slug.trim() === '') {
    return ''
  }

  return slug
    .split('_')
    .filter((part) => part.length > 0)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}
